import { combineReducers } from 'redux'

import tenantsList from './tenantsList'
import currentTenant from './currentTenant'

export default combineReducers({
  tenantsList,
  currentTenant,
})
